<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<section class="feedback-questions-content-section" [id]="section?.uid">
  <div class="feedback-questions-content-section-top">
    <div class="feedback-questions-content-title large bold">
      {{ section?.title }}
    </div>
  </div>

  <div class="feedback-questions-content-section-inner">
    <ng-container *ngFor="let item of section?.includedQuestions; let i = index">
      @if (item.question.type === 'CHOICE_QUESTION') {
        <ptl-feedback-providers-question-answer-choice
          [answers]="section.enrichedAnswers"
          [feedbackRecipient]="feedbackRecipient"
          [question]="item"
          [language]="language"
          [organization]="organization"
        >
        </ptl-feedback-providers-question-answer-choice>
      }

      @if (item.question.type === 'SLIDER_QUESTION') {
        <ptl-feedback-providers-question-answer-slider
          [answers]="section.enrichedAnswers"
          [feedbackRecipient]="feedbackRecipient"
          [question]="item"
          [language]="language"
          [organization]="organization"
        >
        </ptl-feedback-providers-question-answer-slider>
      }

      <ptl-feedback-providers-question-answer-text
        [answers]="section.enrichedAnswers"
        [feedbackRecipient]="feedbackRecipient"
        [question]="item"
        [language]="language"
        [organization]="organization"
        *ngIf="item.question.type === 'TEXT_INPUT_QUESTION'"
      >
      </ptl-feedback-providers-question-answer-text>
    </ng-container>
  </div>
</section>
